import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import EthosV2AsyncReaderForm from '../forms/ethos-v2-async-reader-form';
import { ethosV2AsyncReaderValidationSchema } from '../schema/ethosV2AsyncReader.js';

export default function EthosV2AsyncReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Ethos V2 Async Reader Node Details',
        altText: 'Ethos V2 Async Reader Node',
        defaultLabel: 'Ethos V2 Async Reader Node',
      }}
    >
      <CommonNode
        FormComponent={EthosV2AsyncReaderForm}
        schemaResolver={ethosV2AsyncReaderValidationSchema}
      />
    </NodeProvider>
  );
}
